import { Link, useLocation } from 'react-router-dom';
import type { User } from '../../services/api';
import Avatar from '../shared/Avatar';
import NotificationBell from '../shared/NotificationBell';

const ROUTE_TITLES: Record<string, string> = {
  '/': 'Início',
  '/tarefas': 'Tarefas',
  '/entrevistas/pendentes': 'Entrevistas Pendentes',
  '/entrevistas/agendadas': 'Entrevistas Agendadas',
  '/chamados': 'Chamados',
  '/reunioes': 'Reuniões',
  '/configuracoes': 'Configurações',
  '/atividades': 'Registro de Atividades',
};

interface HeaderProps {
  user?: User;
}

export default function Header({ user }: HeaderProps) {
  const location = useLocation();

  const title = ROUTE_TITLES[location.pathname]
    || (location.pathname.startsWith('/reunioes/') ? 'Reunião'
      : location.pathname.startsWith('/entrevistas') ? 'Entrevistas'
      : 'Presidência');

  return (
    <header className="bg-brand-500 text-white sticky top-0 z-40 safe-top">
      <div className="max-w-2xl mx-auto px-4 h-14 flex items-center justify-between">
        {/* App name / page title */}
        <div className="flex items-center gap-3">
          <h1 className="text-base font-semibold leading-tight">
            {title === 'Início' ? (
              <span className="text-white">Presidência da Estaca</span>
            ) : title}
          </h1>
        </div>

        {/* Right: Bell + Avatar */}
        <div className="flex items-center gap-1">
          <NotificationBell />
          {user && (
            <Link to="/configuracoes" className="flex-shrink-0">
              <Avatar
                name={user.name}
                photoUrl={user.photo_url}
                size="sm"
                className="ring-2 ring-white/30"
              />
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
